// extracted by mini-css-extract-plugin
module.exports = {"title":"home_title__2CxKu","button":"home_button__1QuFS","bar":"home_bar__2Alp5"};